/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var OSMSource = __ol.source.OSM;
var OSM_ATTRIBUTIONS = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors.';
var OSM_URL_TEMPLATE = 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png';
var OSM_MAX_ZOOM = 19;

var props = {
  attributions: {
    type: [String, Array],
    default: OSM_ATTRIBUTIONS
  },
  maxZoom: {
    type: Number,
    default: OSM_MAX_ZOOM
  },
  url: {
    type: String,
    default: OSM_URL_TEMPLATE
  }
};

var methods = {
  createSource: function createSource() {
    // always EPSG:3857, size: 256x256, format png
    return new OSMSource({
      url: this.urlTmpl,
      attributions: this.attributions,
      crossOrigin: this.crossOrigin,
      maxZoom: this.maxZoom,
      cacheSize: this.cacheSize,
      opaque: this.opaque,
      reprojectionErrorThreshold: this.reprojectionErrorThreshold,
      wrapX: this.wrapX
    });
  }
};

var Source = {
  name: 'vl-source-osm',
  mixins: [core.xyzSource],
  props: props,
  methods: methods
};

var index = {
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/osm-source/index.js
// module id = 1190
// module chunks = 1